import React, { useState } from "react";
import { useGetCategoriesQuery } from "../../../redux/service/modules/admin";
import PaginatedDataTable from "../../../components/table/PaginatedDataTable";
import Layout from "../../../components/layout/Layout";
import { CustomAdminLayout } from "../../../components/layout/CustomAdminLayout";
import CategoryDialog from "./CategoryDialog";
const CategoryDetails = () => {
    const [open, setOpen] = useState(false);
    const [searchText, setSearchtext] = useState("");

    // Debounce function
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const handleSearch = debounce((value) => {
        setSearchtext(value);
    }, 500);
    return (
        <Layout>
            <CustomAdminLayout
                title={"Category Details"}
                createButtonText={"Add New Category"}
                createOnClick={() => {
                    setOpen(true);
                }}
                showSearchInput
                showCreateButton={true}
                onSearch={handleSearch}
                searchPlaceholder={"Search Categories"}
            >
                <PaginatedDataTable
                    queryHook={useGetCategoriesQuery}
                    title="Category Management"
                    paginationEnabled={true}
                    showEditColumn={true}
                    showCheckboxColumn={false}
                    appliedFilters={{ search: searchText }}
                    dialogType={"category"}
                />
                <CategoryDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    isEdit={false}
                    title={"Add New Category"}
                    ctaText={"ADD CATEGORY"}
                />
            </CustomAdminLayout>
        </Layout>
    );
};

export default CategoryDetails;
